<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window" :class="{'small' : giftList.length  == 1 , 'mid' : giftList.length && giftList.length < 5}">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="reward-view" v-if="giftList.length">
                        <div class="list-view">
                            <div class="reward-item" v-for="(item,index) in giftList" :key="index">
                                <div class="r-wrapper" v-tips="item.giftId" v-if="item.giftId != 'hb' && item.giftId != 'hb1w'">
                                    <div class="pic">
                                        <game-item :locked="true" :id="item.giftId" :num="item.sendNum || item.num || 1"></game-item>
                                    </div>                                
                                </div>
                                
                                <div class="rb-pic" v-else>
                                    <div class="rb-icon" :class="'rb-' + item.sendNum"></div>
                                </div>  
                            </div>
                        </div>

                    </div>

                    <div class="notice">奖励将发放至军师邮箱或支付宝，请及时查收</div>

                    <div class="u-btn ok" @click="closeModal"></div>

                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>


    .msg-modal{
        width: 690px;
        height: 513px;
        background-image: url(~@/assets/images/modal/bg-modal-result_lg.png);
        
        &.small{
            width: 580px;
            height: 403px;
            background-image: url(~@/assets/images/modal/bg-modal-result.png);            
        }
    }

    .title{
        width: 100%;
        height: 49px;
        margin: 0 auto 30px;
        background-repeat : no-repeat;
        background-position : center;
        background-image: url(~@/assets/images/modal/title-result.png); 
    }

    .reward-view{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 615px;
        height: 224px;
        margin: 0 auto 12px;
        padding-top: 18px;
        box-sizing: border-box;
        background-image: url(~@/assets/images/modal/result-view_lg.png);
        
        .list-view{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;            
        }
    }

    .small .reward-view{
        align-items: center;
        justify-content: center;      
        width: 502px;
        height: 114px;
        margin: 0 auto;
        padding-top: 8px;
        background-image: url(~@/assets/images/modal/result-view.png); 
    }

    .reward-item{
        position: relative;
        margin: 0 10px 18px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 82px;
        height: 82px;
        margin: 0 12px 6px;
        background-image: url(~@/assets/images/modal/bg-item_d.png);


        transform: scale(0);
        opacity: 0;
        transform-origin: center;
        animation: box_show 0.4s;
        animation-fill-mode: forwards;

        @for $i from 1 through 10{
            &:nth-child(#{$i}) {                
                animation-delay: $i*0.5s;               
            }
        }      
    }

    .r-wrapper{
        position: relative;
        width: 68px;
        height: 68px;
        margin: 0 auto;
    }

    .r-wrapper>.pic{
        position: relative;
        width: 100%;
        height: 100%;
    }


    .notice{
        margin-top: 10px;
        text-align: center;
        font-size: 24px;
        color: #f8e1dc;
    }

    .u-btn.ok{
        width: 254px;
        height: 83px;
        margin: 15px auto 0;
        background-image: url(~@/assets/images/modal/btn-ok.png);   
    }

</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            rid : 1,
            giftList : [],
            gacha_index : 1,
            rest : 10,
            cost : 0,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },           
        closeModal(){

            //test
            //this.giftList.push({sendNum : 100 , giftId : 'hb' , giftType : 3 , orderId : 'test'})

            let ret = this.giftList.filter( i => (i.giftId == 'hb' || i.giftId == 'hb1w'))

            if(ret.length){
                this.destroyElement();
                this.$opt_modal({ gacha_list : ret });
            }
            // else if(ret.length && ((this.$store.state.userinfo.uflag & 256) != 256)){
            //     this.destroyElement();
            //     this.$ali_modal({ gacha_list : ret });
            // }
            else{
                this.destroyElement();
            }

        },            
    },    
}
</script>